export default {
    "button.create": "建立",
    "button.upload": "上傳",
    "button.cancelEdit": "取消編輯",
    "button.edit": "編輯",
    "button.restore": "恢復",
    "button.delete": "刪除",
    "button.display_more": "顯示更多",
    "button.confirm": "確認",
    "button.clear": "清除",
    "button.pick": "選擇",
    "button.cancel": "取消",
    "button.forgotten_pwd": "發送密碼重設電子郵件",
    "button.back": "返回上一頁",
    "button.reload": "重新載入",

    "tag.location": "位置",
    "tag.ev_schedule": "時間表",
    "tag.ev_charger": "充電椿",
    "tag.play_list": "播放清單",
    "tag.report": "報告",
    "tag.setting": "設置",
    "tag.stakeholders": "利益相關者",

    "table.select": "選擇",
    "table.items": "項目",
    "table.additional_details": "更多詳情",
    "table.state": "狀態",
    "table.state_all": "全部",
    "table.state_deleted": "刪除",
    "table.state_existing": "現存",
    "table.deleted_at": "刪除時間",

    "table.ev_schedule.action": "操作",
    "table.ev_schedule.from_date": "起始日期",
    "table.ev_schedule.to_date": "截止日期",
    "table.ev_schedule.from_time": "起始時間",
    "table.ev_schedule.to_time": "截止時間",
    "table.ev_schedule.billing_scheme": "計費方案",
    "table.ev_schedule.billing_scheme_kwh": "kwh",
    "table.ev_schedule.billing_scheme_time": "Time",
    "table.ev_schedule.promotion_id": "Id",

    "ev_charger.display_name": "顯示名稱",
    "ev_charger.serial_number": "序列號",
    "ev_charger.voltage": "電壓",
    "ev_charger.current_type": "電流類型",
    "ev_charger.device_status": "狀態",
    "ev_charger.power": "功率",

    "table.transaction.trx_id": "Id",
    "table.transaction.reference_code": "訂單編號",

};
